import { defineMessages } from "react-intl";

const PREFIX = "User.UserPage";
export default defineMessages({
  myProfile: {
    id: `${PREFIX}.myProfile`,
    defaultMessage: "My Profile",
  },
  settings: {
    id: `${PREFIX}.settings`,
    defaultMessage: "Settings",
  },
});
